import Vue from 'vue'
import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV)
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
// import Layout from '../views/layout/Layout'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  {
    path: '/',
    component: _import('login/Layout'),
    hidden: true,
    redirect: 'login',
    children: [
      {
        path: 'login',
        name: 'Login',
        component: _import('login/index'),
        hidden: true
      },
      {
        path: 'login/pwdFind',
        name: 'PwdFind',
        component: _import('login/pwdFind/index'),
        hidden: true
      },
      {
        path: 'login/pwdChange',
        name: 'PwdChange',
        component: _import('login/pwdChange/index'),
        hidden: true
      }
    ]
  },

  {
    path: '/index.html',
    hidden: true,
    redirect: 'login'
  },

  {
    path: '/index',
    hidden: true,
    redirect: 'login'
  },
  {
    path: '/logout',
    hidden: true,
    component: _import('logout/index'),
  },
  { path: '/404', component: _import('404'), hidden: true },

  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  mode: 'history', // 后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js